<script setup lang="ts">
import type { LicenseEntitlementNumericKey, LicenseScope } from '#layers/license/types/license';
import { computed } from 'vue';
import { useLicenseStore, useSystemLicenseStore } from '#layers/license/stores/license';

const { entitlementKey, scope } = defineProps<{
	entitlementKey: LicenseEntitlementNumericKey;
	scope?: LicenseScope;
}>();

const { limit, licenseLoaded } = useScopedLicenseStore();

const isVisible = computed(() =>
	licenseLoaded.value
	&& limit.value.gate !== 'none'
	&& typeof limit.value.usage === 'number'
	&& typeof limit.value.allowance === 'number',
);

const color = computed(() => {
	if (limit.value.status === 'block') return 'error';
	if (limit.value.status === 'warn') return 'warning';
	return 'neutral';
});

function useScopedLicenseStore() {
	const license = computed(() => scope === 'system' ? useSystemLicenseStore() : useLicenseStore());
	const limit = computed(() => license.value.getEntitlementLimit(entitlementKey));
	const licenseLoaded = computed(() => license.value.isLoaded);

	return { limit, licenseLoaded };
}
</script>

<template>
	<DBadge
		v-if="isVisible"
		:color
		variant="subtle"
		:label="$t('organization.dashboard.settings.license.value.count', { usage: limit.usage, limit: limit.allowance })"
	/>
</template>
